import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;
const EVENTS_API_URL = `${API_URL}/api/events`;
const TICKET_PURCHASES_API_URL = `${API_URL}/api/ticket_purchases`;

export const createEvent = async (data, token, onProgress) => {
  try {
    const response = await axiosInstance.post(EVENTS_API_URL, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
      },
      onUploadProgress: (progressEvent) => {
        if (!progressEvent.total) return;
        const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        if (onProgress) onProgress(percent);
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error creating event:', error.response ? error.response.data : error.message);
    throw error;
  }
};

export const fetchActiveEvents = async () => {
  const res = await axiosInstance.get(`${EVENTS_API_URL}/active`);
  return res.data;
};

export const fetchEventById = async (eventId) => {
  try {
    const response = await axiosInstance.get(`${EVENTS_API_URL}/${eventId}`);
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching event details:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const fetchEvents = async (params = {}) => {
  try {
    const endpoint = `${EVENTS_API_URL}/recommended`;
    const response = await axiosInstance.get(endpoint, { params });
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching events:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const fetchMyEvents = async (logoutCallback) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    };
    const response = await axiosInstance.get(`${EVENTS_API_URL}/myevents`, config);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.error('Token expired or unauthorized. Logging out...');
      if (logoutCallback) logoutCallback(); // Trigger logout
    }
    throw error;
  }
};

export const fetchAllTicketPurchases = async () => { // Fetch all ticket purchases
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    };
    const response = await axiosInstance.get(`${TICKET_PURCHASES_API_URL}/purchases`, config);
    return response.data;
  } catch (error) {
    console.error('Error fetching all ticket purchases:', error.response ? error.response.data : error.message);
    throw error;
  }
};

export const fetchTicketPurchases = async (eventId) => { // Fetch ticket purchases for a specific event
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    };
    const response = await axiosInstance.get(`${TICKET_PURCHASES_API_URL}?eventId=${eventId}`, config);
    return response.data;
  } catch (error) {
    console.error('Error fetching ticket purchases:', error.response ? error.response.data : error.message);
    throw error;
  }
};

export const updateEvent = async (id, data, token, onProgress) => {
  try {
    const response = await axiosInstance.put(`${EVENTS_API_URL}/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
      },
      onUploadProgress: (progressEvent) => {
        if (!progressEvent.total) return;
        const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        if (onProgress) onProgress(percent);
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating event:', error.response ? error.response.data : error.message);
    throw error;
  }
};

export const deleteEvent = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
         'Authorization': `Bearer ${token}`
      }
    };
    const response = await axiosInstance.delete(`${EVENTS_API_URL}/${id}`, config);
    return response.data;
  } catch (error) {
    console.error('Error deleting event:', error.response ? error.response.data : error.message);
    throw error;
  }
};

  // Admin functions
export const fetchAllEvents = async () => {
  try {
    const token = localStorage.getItem('adminToken');
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    };
    const response = await axiosInstance.get(EVENTS_API_URL, config);
    return response.data;
  } catch (error) {
    console.error('Error fetching events:', error.response ? error.response.data : error.message);
    throw error;
  }
};
export const getAllTicketSales = async () => {
  try{
  const token = localStorage.getItem('adminToken');
  const config = { headers: { Authorization: `Bearer ${token}` } };
  const response = await axiosInstance.get(`${EVENTS_API_URL}/all-ticket-sales`, config);
  return response.data;
  } catch (error) {
    console.error('Error fetching ticket sales:', error.response ? error.response.data : error.message);
    throw error;
  }
};

export const purchaseByEventId = async (eventId) => {
  try{
  const token = localStorage.getItem('adminToken');
  const config = { headers: { Authorization: `Bearer ${token}` } };
  const response = await axiosInstance.get(`${TICKET_PURCHASES_API_URL}?eventId=${eventId}`, config);
  return response.data;
  } catch (error) {
    console.error('Error fetching event purchases:', error.response ? error.response.data : error.message);
    throw error;
  }
};

export const updateEventStatus = async (eventId, status) => {
  const token = localStorage.getItem('adminToken');
  const response = await axiosInstance.patch(
    `${EVENTS_API_URL}/${eventId}/status`,
    { status },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return response.data;
};